import { AxiosResponse } from 'axios'

import { ServiceConfig } from '../../../../shared/services/ServiceConfig'
import IFindTipoCaminhaoRequest from '../../domain/entities/FindTipoCaminhaRequest'
import ITipoCaminhao from '../../domain/entities/TipoCaminhao'
import { ITipoCaminhaoRepository } from '../../domain/repositories/ITipoCaminhaoRepository'

const http = new ServiceConfig()
export default class TipoCaminhaoRepository implements ITipoCaminhaoRepository {
  public async findByDescricao(
    params: IFindTipoCaminhaoRequest,
  ): Promise<ITipoCaminhao[]> {
    const response: AxiosResponse<ITipoCaminhao[]> = await http.get(
      '/tipos/caminhao',
      {
        params: {
          descricao: params?.descricao,
        },
      },
    )

    return response.data
  }

  public async findAll(): Promise<ITipoCaminhao[]> {
    const response: AxiosResponse<ITipoCaminhao[]> = await http.get(
      '/tipos-caminhao',
    )
    return response.data
  }
}
